module.exports = __webpack_public_path__ + "media/apps.fc9097f7.png";